export default __webpack_public_path__ + "static/media/dance1.c55f8521.mp4";